import React, { useEffect } from 'react';



export default function IC_supplier_transport_document_rows({ data, entity = null, setDataKeyValue }) {

    useEffect(() => {
        console.warn('DATA', data);
        if (data.idItemModel) {
            if (data.name === "" && data.name !== data.idItemModel.name) {
                setDataKeyValue('name', data.idItemModel.name)
            }
            if (data.measureUnit === "" && data.measureUnit !== data.idItemModel.measureUnit) {
                setDataKeyValue('measureUnit', data.idItemModel.measureUnit)
            }
        }
    }, [data]);


    useEffect(() => {
        if (data.idItemModel) {
            if (data.name !== data.idItemModel.name) {
                setDataKeyValue('name', data.idItemModel.name)
            }
            if (data.measureUnit !== data.idItemModel.measureUnit) {
                setDataKeyValue('measureUnit', data.idItemModel.measureUnit)
            }
        }
    }, [data.idItemModel]);



    return (
        <>
        </>
    )
};